import { render, staticRenderFns } from "./CancelPolicy.vue?vue&type=template&id=f21a7208&scoped=true"
import script from "./CancelPolicy.vue?vue&type=script&lang=js"
export * from "./CancelPolicy.vue?vue&type=script&lang=js"
import style0 from "./CancelPolicy.vue?vue&type=style&index=0&id=f21a7208&prod&lang=less&scoped=true"
import style1 from "./CancelPolicy.vue?vue&type=style&index=1&id=f21a7208&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21a7208",
  null
  
)

export default component.exports